export const CityName = ({ name }) =>
  name ? <div className="city-name">{name}</div> : null
